'use client';

import React from 'react';
import { useTranslations } from 'next-intl';

export function StoreFooter() {
  const t = useTranslations('storeFooter');
  return (
    <footer className="mt-24" style={{ backgroundColor: '#000', color: '#fff' }}>
      <div
        className="container-site flex flex-col md:flex-row items-center justify-between gap-4"
        style={{ padding: '32px 0' }}
      >
        <p className="text-sm text-gray-400">{t('copyright')}</p>
        <a
          href="/"
          className="text-sm text-gray-300 hover:text-white transition-colors duration-150"
        >
          {t('voltarAoSite')}
        </a>
      </div>
    </footer>
  );
}
